export default "__VITE_ASSET__DCBEB1BO__"